/**
 * Resolución robusta de Empresa / Producto para una venta de la tabla `sales`.
 *
 * Fuente CANÓNICA: client_id → clientes.empresa / clientes.producto.
 * La relación venta↔cliente se resuelve SIEMPRE por id (regla 10.7 / 8): el
 * `clientesById` es un mapa { [clientes.id]: cliente }. Nunca se compara por texto
 * para determinar a qué cliente pertenece la venta.
 *
 * FALLBACK (solo si no hay client_id o el campo canónico viene vacío): parsear el
 * texto libre `sales.cliente` por "|" → izquierda = empresa, derecha = producto
 * (ambos con trim). Si no hay "|": empresa = cliente completo, producto = null.
 *
 * `fuente` indica de dónde salió el dato ("cliente" | "parseo"), útil para auditar
 * cuántas ventas cayeron en el fallback.
 *
 * @param {Object} sale - fila de `sales` (usa client_id y cliente).
 * @param {Object} clientesById - mapa { [id]: clienteRow } con empresa/producto.
 * @returns {{ empresa: string, producto: string|null, fuente: "cliente"|"parseo" }}
 */
export const resolverEmpresaProducto = (sale, clientesById = {}) => {
  const cliente = sale?.client_id != null ? clientesById[sale.client_id] : null;
  const empresaCanon = (cliente?.empresa || "").trim();
  const productoCanon = (cliente?.producto || "").trim();

  if (empresaCanon) {
    return { empresa: empresaCanon, producto: productoCanon || null, fuente: "cliente" };
  }

  // Fallback: texto libre de la venta.
  const raw = (sale?.cliente || "").trim();
  if (raw.includes("|")) {
    const [emp, ...resto] = raw.split("|");
    const empresa = emp.trim() || raw;
    const producto = resto.join("|").trim() || null;
    return { empresa, producto, fuente: "parseo" };
  }
  return { empresa: raw, producto: null, fuente: "parseo" };
};
